// helpers/formatPhoneNumberHelper.js
export const formatPhoneNumber = (value) => {
  let digits = value.replace(/\D/g, ''); // Strip non-digits
  // Remove leading 1 (US country code) if present and number is 11 digits
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  digits = digits.slice(0, 10); // Limit to 10 digits
  if (!digits) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};